import React from 'react';
import { Box, Flex, Text, Avatar, VStack } from '@chakra-ui/react';
import { Home } from 'lucide-react';
import { useCommitteeContext } from '../context/CommitteeContext';
import { useNavigate } from 'react-router-dom';
const TEAL = '#00897B';
const SIDEBAR_BG = '#C8E6C0';
const CELL_BG = '#F1FAF1';
const CELL_ACTIVE_BG = '#B2DFDB';
export const committeeMembers = [{
  position: 'President',
  name: 'Commissioner Gordon'
}, {
  position: 'Vice President',
  name: 'Bruce Wayne'
}, {
  position: 'Pos 1',
  name: 'Dick Grayson'
}, {
  position: 'Pos 2',
  name: 'Vacant'
}, {
  position: 'Pos 3',
  name: 'Barbara Gordon'
}, {
  position: 'Pos 4',
  name: 'Alfred Pennyworth'
}, {
  position: 'Pos 5',
  name: 'Harvey Dent'
}];
export function CommitteeSidebar() {
  const {
    selectedIndex,
    setSelectedIndex
  } = useCommitteeContext();
  const navigate = useNavigate();
  return <Box as="nav" bg={SIDEBAR_BG} w="290px" minW="290px" position="fixed" top="64px" left={0} bottom={0} zIndex={90} display="flex" flexDirection="column" overflowY="hidden" data-id="element-58">
      {/* User Box */}
      <Flex align="center" gap={3} px={4} py={4} borderBottom="1px solid rgba(0,137,123,0.25)" flexShrink={0} data-id="element-59">
        <Avatar name="Keith Price" bg="#7B1FA2" color="white" size="md" fontWeight="bold" getInitials={() => 'KP'} data-id="element-60" />
        <Box data-id="element-61">
          <Text fontWeight="bold" color={TEAL} fontSize="md" lineHeight="1.2" data-id="element-62">
            Keith Price
          </Text>
          <Text color={TEAL} fontSize="sm" opacity={0.85} data-id="element-63">
            zMagic Solutions
          </Text>
        </Box>
      </Flex>

      {/* Home nav item */}
      <Box flexShrink={0} pt={2} mb={2} data-id="element-64">
        <Flex align="center" gap={4} px={5} py={3} cursor="pointer" borderRadius="md" _hover={{
        bg: 'rgba(0,137,123,0.12)'
      }} onClick={() => navigate('/welcome')} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && navigate('/welcome')} data-id="element-65">
          <Box color={TEAL} flexShrink={0} data-id="element-66">
            <Home size={26} strokeWidth={1.8} data-id="element-67" />
          </Box>
          <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-68">
            Home
          </Text>
        </Flex>
      </Box>

      {/* Committee member list */}
      <Box flex={1} overflowY="auto" px={3} pt={2} pb={2} sx={{
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-69">
        <VStack align="stretch" spacing={1} data-id="element-70">
          {committeeMembers.map((member, idx) => {
          const isSelected = idx === selectedIndex;
          return <Box key={idx} bg={isSelected ? CELL_ACTIVE_BG : CELL_BG} borderRadius="sm" px={3} py={1.5} borderLeft="3px solid" borderLeftColor={isSelected ? '#004D40' : TEAL} cursor="pointer" onClick={() => setSelectedIndex(idx)} _hover={{
            bg: isSelected ? CELL_ACTIVE_BG : '#E0F2E9'
          }} transition="background 0.15s" data-id="element-71">
                <Text fontSize="10px" fontWeight="600" color={isSelected ? '#004D40' : TEAL} textTransform="uppercase" letterSpacing="0.06em" lineHeight="1.3" data-id="element-72">
                  {member.position}
                </Text>
                <Text fontSize="sm" fontWeight={member.name === 'Vacant' ? 'normal' : 'semibold'} color={member.name === 'Vacant' ? 'gray.400' : isSelected ? '#004D40' : 'black'} fontStyle={member.name === 'Vacant' ? 'italic' : 'normal'} lineHeight="1.3" data-id="element-73">
                  {member.name}
                </Text>
              </Box>;
        })}
        </VStack>
      </Box>
    </Box>;
}